export enum VettingRecordAction {
  Appeal = 'appeal',
  ViewAppealHistory = 'view_appeal_history',
  ViewReport = 'view_report',
  DownloadReport = 'download_report',
  Resend2FA = 'resend_2fa',
}

export const TABLE_COLUMNS = [
  {
    id: 'type',
    label: 'VETTING TYPE',
    sortable: false,
  },
  {
    id: 'partner',
    label: 'VETTING PARTNER',
    sortable: false,
  },
  {
    id: 'status',
    label: 'VETTING STATUS',
    sortable: false,
  },
  {
    id: 'date',
    label: 'REQUESTED DATE',
    sortable: false,
  },
  {
    id: 'validUntil',
    label: 'VALID UNTIL',
    sortable: false,
  },
  {
    id: 'outcome',
    label: 'OUTCOME',
    sortable: false,
  },
  {
    id: 'action',
    label: 'ACTION',
    sortable: false,
  },
];
